import React from "react";
import StoreAction from "../constants/store-action";
export default (props) => {
    const handleDealerSelection = (value) => {
        props.onHandleDealerSelection(value);
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            value: value.id,
            type: "dealerChooser",
            name: "dealer",
        }, () => {
            props.onProceedToNextStep();
        });
    };
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Vilken handlare vill du k\u00F6pa fr\u00E5n?"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "Detta fordon finns tillg\u00E4ngligt hos flera handlare. V\u00E4lj den du vill handla fr\u00E5n!"))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-optionlist": "" },
                React.createElement("ul", { className: "option-list" }, props.orderOptions.getDealerSites().map((dealer) => (React.createElement("li", { key: dealer.id, className: "option-list-item" },
                    React.createElement("button", { className: "option-list-action", onClick: () => handleDealerSelection(dealer) },
                        React.createElement("div", { className: "option-list-action-title" },
                            dealer.name,
                            React.createElement("i", { className: "icon-arrow-right m-l-half" })))))))))));
};
